<template>
  <div>
    <b-card-group class="card-grid">
      <a
        :href="createUserLink(user.model.url)"
        target="_blank"
        v-for="(user, index) in users"
        :key="index"
      >
        <b-card
          :img-alt="user.model.fullname"
          img-top
          :img-src="getCardBannerUrl(user)"
        >
          <img
            :src="user.model.avatar.view_url"
            :alt="user.model.fullname"
            class="user-avatar"
          />
          <div class="user-flag" v-if="user.model.country">
            <img
              :src="user.model.country.flag_url"
              :alt="user.model.country.name"
            />
          </div>
          <h3 class="user-fullname">
            <span>
              {{ user.model.fullname }}
            </span>
            <i
              class="fa fa-check-circle fs-17"
              v-if="user.model.verified_type"
            ></i>
          </h3>
          <div class="user-headline">
            <div v-if="user.model.profile.headline">
              {{ user.model.profile.headline }}
            </div>
          </div>
          <div class="user-skills" v-if="user.model.skill_tags.length">
            <div class="user-skills-text">
              <span class="user-skills-title">
                Skills:
              </span>
              <a
                class="user-skills-text-token"
                :title="tag"
                href="javascript:;"
                v-for="(tag, i) in user.model.skill_tags"
                :key="i"
              >
                <span class="omit max-width-100">
                  {{ tag }}
                </span>
              </a>
            </div>
          </div>
        </b-card>
      </a>
    </b-card-group>
    <infinite-loading @infinite="infiniteHandler">
      <div slot="no-more"></div>
      <div slot="no-results"></div>
    </infinite-loading>
  </div>
</template>

<script>
import { CN_HOST } from "@/configs";
import InfiniteLoading from "vue-infinite-loading";
import { mapActions } from "vuex";

export default {
  components: {
    InfiniteLoading,
  },
  props: {
    users: {
      type: Array,
      default: function() {
        return [];
      },
    },
    nextOffset: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      userDefaultBg: require("@/assets/img/user-theme-bg.png"),
      next_offset: 0,
    };
  },
  methods: {
    ...mapActions("siteBrandSearchUser", ["getSiteBrandSearchUser"]),
    getCardBannerUrl(item) {
      let url =
        item.model?.profile?.theme_home_banner_url ||
        item?.model?.institution_setting?.ui_profile_cover_attachment_url;
      if (url) {
        return url + ".h156.jpg";
      }
      return this.userDefaultBg;
    },
    createTooltipContent(type) {
      const tooltips = {
        institution_member:
          "This user’s account belongs to a verified institution.",
        institution_email:
          "This user’s account is associated with an institution email.",
      };
      return tooltips[type] || "";
    },
    createUserLink(url) {
      return `${CN_HOST}${url}`;
    },
    infiniteHandler($state) {
      this.getSiteBrandSearchUser({
        offset: this.next_offset || this.nextOffset,
      }).then((data) => {
        if (!data.data.length) {
          $state.complete();
        } else {
          $state.loaded();
        }
        this.next_offset = data.extra_data.next_offset;
      });
    },
  },
};
</script>

<style scoped lang="scss">
.card-grid {
  display: grid;
  grid-gap: rem(10);
  grid-template-columns: repeat(auto-fill, minmax(auto, 358px));
  justify-content: center;
  @media (max-width: 400px) {
    grid-template-columns: 1fr;
  }
  > a {
    display: grid;
    width: 100%;
    &:hover {
      text-decoration: none;
    }
    @media (max-width: 550px) {
      max-width: 350px;
      margin: 0 auto;
    }
  }
}
.card {
  border-radius: rem(12);
  overflow: hidden;
  box-shadow: 2px 4px 12px rgba(0, 0, 0, 0.07);
  border: none;
  &:hover {
    cursor: pointer;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.3);
  }

  img {
    height: rem(125);
    object-fit: cover;
  }
  .card-body {
    position: relative;
  }
  .user-avatar {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    border: 5px solid #fff;
    background-color: #fff;
    margin-left: calc(50% - 125px / 2);
    margin-top: -65px;
  }
  .user-flag {
    position: absolute;
    right: rem(15);
    top: rem(15);
    display: inline-block;
    img {
      max-width: rem(25);
      height: auto;
      border: 2px solid white;
      object-fit: contain;
    }
  }
  .user-fullname {
    font-size: rem(20);
    font-weight: 700;
    line-height: rem(27);
    color: #393939;
    text-align: center;
    .fa-check-circle {
      color: #2ecc71;
    }
  }
  .user-headline {
    font-weight: 400;
    font-size: rem(14);
    line-height: rem(20);
    color: #3c3c3c;
  }
  .user-headline {
    height: rem(50);
    overflow: hidden;
    > div {
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }
  }
  .user-skills {
    height: rem(100);
    overflow: hidden;
    > div {
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }
  }
  .user-skills-title {
    font-weight: 600;
    font-size: rem(14);
    line-height: rem(20);
    color: #3c3c3c;
  }
  .user-skills-text {
    margin-top: rem(25);

    &-token {
      text-decoration: none;
      display: inline-flex;
      align-items: center;
      padding: 10px 15px;
      margin: 5px 5px 5px 0;
      border-radius: 16px;
      height: auto;
      line-height: rem(14);
      background: #efeff9;
      color: #639de9;
      border: none;
      font-size: rem(12);
    }
  }
}
</style>
